import URL from '../api_url';

export const FONT_API = `${URL}/font`;